import React from 'react';
import EmptyBox from '@wconcept/wconcept-ui-renewal/src/components/molecules/_empty/EmptyBox';
import { EmptyStateProps } from '../types';

const EmptyState = React.memo<EmptyStateProps>(
  ({ products, selectedFilters, emptyText, onReset }: EmptyStateProps) => {
    const hasNoProducts = products.length === 0;
    const hasSelectedFilter = selectedFilters && selectedFilters.length > 0;

    if (hasNoProducts && hasSelectedFilter) {
      return (
        <EmptyBox
          msg="필터 검색 결과가 없습니다.<br />선택한 필터를 변경해보세요."
          btnText="필터 재설정"
          onClick={() => {
            onReset?.();
          }}
        />
      );
    }
    if (hasSelectedFilter) {
      return (
        <EmptyBox
          msg="필터 검색 결과가 없습니다.<br />선택한 필터를 변경해보세요."
          btnText="필터 재설정"
          onClick={onReset}
        />
      );
    }
    if (products.length === 0) {
      return <EmptyBox msg={emptyText || '상품이 없습니다.'} />;
    }

    return <EmptyBox msg={emptyText || '상품이 없습니다.'} />;
  }
);

EmptyState.displayName = 'EmptyState';

export default EmptyState;
